import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import WaveSurfer from 'wavesurfer.js'
import { DialogService } from '../../services/dialog.service';

@Component({
  selector: 'app-waveform-audio-player',
  templateUrl: './waveform-audio-player.component.html',
  styleUrls: ['./waveform-audio-player.component.css']
})
export class WaveformAudioPlayerComponent implements OnInit, OnDestroy {

  @ViewChild('waveform', { static: true }) waveformContainer: ElementRef<HTMLElement>;

  @Input() src: string;
  @Input() blob?: Blob;
  @Input() showClearButton: boolean = false;
  @Input() backgroundColor: string = '#28292b';
  @Input() waveColor?: string;
  @Input() progressColor?: string;
  @Input() height: number = 36;
  @Input() disabled: boolean = false;

  @Output() onClear = new EventEmitter();

  wavesurfer: WaveSurfer;
  private themeObserver: MutationObserver;

  constructor(
    private dialogService: DialogService
  ) { }

  ngOnInit(): void {
    this.setupWaveSurver();
    this.watchThemeChanges();
  }

  ngOnDestroy(): void {
    this.themeObserver?.disconnect();
    this.wavesurfer?.destroy();
  }

  setupWaveSurver() {
    this.wavesurfer?.destroy();
    this.wavesurfer = WaveSurfer.create({
      container: this.waveformContainer.nativeElement,
      waveColor: this.getWaveColor(),
      progressColor: this.getProgressColor(),
      height: this.height,
      dragToSeek: true,
      url: !this.blob ? this.src : undefined
    });
    if (this.blob) this.wavesurfer.loadBlob(this.blob);

    this.wavesurfer.on('error', (error: Error) => {
      console.log(error);
    });

    this.wavesurfer.on('finish', () => {
      this.wavesurfer.pause();
      this.wavesurfer.setTime(0);
    });
  }

  togglePlay() {
    if (!this.wavesurfer) return;
    this.wavesurfer.playPause();
  }

  onClearPressed() {
    this.onClear.emit();
  }

  private watchThemeChanges() {
    this.themeObserver = new MutationObserver(() => {
      if (this.waveColor && this.progressColor) return;
      this.wavesurfer?.setOptions({
        waveColor: this.getWaveColor(),
        progressColor: this.getProgressColor(),
      });
    });
    this.themeObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  private getWaveColor(): string {
    return this.waveColor || (this.isLightTheme() ? '#000000' : '#a0a0a0');
  }

  private getProgressColor(): string {
    return this.progressColor || (this.isLightTheme() ? '#000000' : '#ffffff');
  }

  private isLightTheme(): boolean {
    return document.body.classList.contains('theme-light');
  }

}
